import React from 'react';
import WhatsappButton from "../../Components/WhatsappButton";
import Horarios from "../../Components/Lista/Horarios";
import styled from "styled-components";

const Text=styled.h1`
margin:0;
justify-self:center;
font-size:24px;`;

const SubText=styled.h3`
text-align:center;
margin:0;
margin-top: 1rem;
justify-self:center;
font-size:20px;
font-weight:normal;

@media screen and (max-width:375px)
{
    font-size:17px;
}`;



const FullCapacity = ({Logo}) => 
{
    return <>
        {Logo}
            <div style={{display:"grid",justifyContent:"center",alignContent:"center"}}>
                <Text>Disculpas! <span role="img" aria-label="Emoji mirando para abajo">😔</span></Text> 
                <SubText style={{marginTop:"8px", padding:"0px 20px", fontSize:"22px"}}>En este momento hay mas de 20 grupos anotados, por favor intentar mas tarde.</SubText>
                <Horarios/>
               <WhatsappButton bottom="0.25em" number="5491138141940"/>
            </div>
        </>
}

export default FullCapacity
